import templateStr from 'text!./templates/policy-dwelling-info.html';

export default [function () {

    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            'policyDwelling': '=',
            'lineCoverages': '=',
            'policy': '='
        },

        controller: ['$scope', 'TranslateService', 'ViewModelService', function ($scope, TranslateService, ViewModelService) {

            updateDwelling();
            updateCoverages();
            $scope.YesNo = function (boolVal) {
                var translationKey = 'policy.ho.directives.policy-dwelling-info.' + (boolVal ? 'Yes' : 'No');
                return TranslateService.instant(translationKey);
            };
            $scope.$watch('policy', function () {
                updateDwelling();
                updateCoverages();
            });

            function updateDwelling() {
                $scope.policyDwellingExt = ViewModelService.create($scope.policyDwelling, 'pc', 'edge.capabilities.policy.lob.homeowners.dto.DwellingDTO');
            }

            function updateCoverages() {
                var coverages = $scope.policy.lobs.homeOwners.coverageDTOs.concat($scope.policy.lobs.homeOwners.dwellingDTO.coverageDTOs);
                $scope.allCoverages = {
                    sectionICoverages: [],
                    sectionIICoverages: [],
                    additionalLiabilityCoverages: [],
                    additionalPropertyCoverages: [],
                    scheduledItems: []
                };
                coverages.forEach(function (cov) {
                    switch (cov.categoryCodeIdentifier) {
                        case 'HOPSectionICovCat':
                        case 'HODW_SectionI_HOE':
                            $scope.allCoverages.sectionICoverages.push(cov);
                            break;
                        case 'HOPSectionIICovCat':
                        case 'HODW_SectionII_HOE':
                            $scope.allCoverages.sectionIICoverages.push(cov);
                            break;
                        case 'HOPAdditionalCovCat':
                        case 'HOLI_Additional_HOE':
                            $scope.allCoverages.additionalLiabilityCoverages.push(cov);
                            break;
                        case 'HOPPCAdditionalCovCat':
                        case 'HODW_Additional_HOE':
                            $scope.allCoverages.additionalPropertyCoverages.push(cov);
                            break;
                        case 'HOPScheduledItemCovCat':
                        case 'HODW_SchedulesCov_HOE':
                            if (cov.specialLimits) {
                                cov.specialLimits.forEach(function (coverageItem) {
                                    $scope.allCoverages.scheduledItems.push(coverageItem);
                                });
                            } else if (cov.scheduledProperty) {
                                cov.scheduledProperty.forEach(function (coverageItem) {
                                    $scope.allCoverages.scheduledItems.push(coverageItem);
                                });
                            }
                            break;
                        default:
                            break;
                    }
                });
            }
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policy/ho/directives/PolicyDwellingInfo.js
// module id = 2078
// module chunks = 0